import { render } from "./prize_order.vue?vue&type=template&id=a9c285d6"
import script from "./prize_order.vue?vue&type=script&lang=js"
export * from "./prize_order.vue?vue&type=script&lang=js"

import "./prize_order.vue?vue&type=style&index=0&id=a9c285d6&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__